import React from "react";
import '../../App.css';
import { Formik, Form, Field } from "formik";
import LoadingButton from '@mui/lab/LoadingButton';
import axios from "axios";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import Header from "../Header";
import Cookies from 'js-cookie'
import LogOut from "../Account/LogOut";
import Swal from 'sweetalert2'
import withReactContent from "sweetalert2-react-content";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Grid, Autocomplete, TextField } from "@mui/material";
function NewTicket() {
  const navigate = useNavigate();
  const [Category1, setCategory1] = React.useState([]);
  const [Category2, setCategory2] = React.useState([]);
  const [Category3, setCategory3] = React.useState([]);
  const [LoadingAPI,setLoadingAPI]= React.useState(false);
  const [showUnifierFields, setShowUnifierFields] = React.useState(false);
  const [shellOptions, setShellOptions] = React.useState([]);
  const [businessProcessOptions, setBusinessProcessOptions] = React.useState([]);
  const [projectOptions, setProjectOptions] = React.useState([]);
  const [selectedLocation, setSelectedLocation] = React.useState('');
  const MySwal = withReactContent(Swal);
  const validationSchema = Yup.object().shape({
    location: Yup.string().required("Please select your current location"),
    ServiceCategory1: Yup.string().required("Select Department to provide you service حدد القسم الذي سيتم تقديم الخدمة"),
    ServiceCategory2: Yup.string().required("Select the general issue حدد المشكله العامة"),
    ServiceCategory3: Yup.string().required("Select the specific issue حدد المشكلة المحددة"),
    Issue: Yup.string().required("Issue is required"),
    token: Yup.string().required("Captcha is required"),
    new_shell: Yup.string().when('ServiceCategory1', {
      is: (val) => val && Category1.find(cat => cat.id === val)?.name.toLowerCase().includes('unifier'),
      then: (schema) => schema.required("Shell field is required").max(1000, "Maximum 1000 characters allowed"),
      otherwise: (schema) => schema.max(1000, "Maximum 1000 characters allowed")
    }),
    new_businessprocess: Yup.string().when('ServiceCategory1', {
      is: (val) => val && Category1.find(cat => cat.id === val)?.name.toLowerCase().includes('unifier'),
      then: (schema) => schema.required("Business Process field is required").max(1000, "Maximum 1000 characters allowed"),
      otherwise: (schema) => schema.max(1000, "Maximum 1000 characters allowed")
    }),
    new_project: Yup.string().when('ServiceCategory1', {
      is: (val) => val && Category1.find(cat => cat.id === val)?.name.toLowerCase().includes('unifier'),
      then: (schema) => schema.required("Project field is required").max(1000, "Maximum 1000 characters allowed"),
      otherwise: (schema) => schema.max(1000, "Maximum 1000 characters allowed")
    }),
    new_recordno: Yup.string().when('ServiceCategory1', {
      is: (val) => val && Category1.find(cat => cat.id === val)?.name.toLowerCase().includes('unifier'),
      then: (schema) => schema.required("Record Number field is required").max(100, "Maximum 100 characters allowed"),
      otherwise: (schema) => schema.max(100, "Maximum 100 characters allowed")
    }),
    attachments: Yup.array().of(
      Yup.object().shape({
        data: Yup.string(),
        documentbody: Yup.string(),
        mimetype: Yup.string(),
        isdocument: Yup.boolean(),
        filename: Yup.string(),
        filesize: Yup.number(),
      })
    )
    .test('fileSize', 'One or more attachments exceed 15MB', (value) => {
      if (!value || value.length === 0) return true;
      return value.every(file => file?.filesize <= Number(15 * 1024 * 1024));
    })
    .test('totalFiles', 'Maximum 5 files allowed', (value) => {
      if (!value) return true;
      return value.length <= 5;
    }),
  });

  React.useEffect(() => {
    let endpoints = [
      `${process.env.REACT_APP_Back_URL}/tickets/category1`,
      `${process.env.REACT_APP_Back_URL}/tickets/category2`,
      `${process.env.REACT_APP_Back_URL}/tickets/category3`,
    ];
    
    axios.get(endpoints[0])
      .then((resp) => {
        let arr = resp.data.sort((a, b) => (a.new_name.toUpperCase() > b.new_name.toUpperCase()) ? 1 : ((b.new_name.toUpperCase() > a.new_name.toUpperCase()) ? -1 : 0));
        setCategory1(arr.map((row) => {
          return { id: row.new_category1id, name: row.new_name };
        }));      
        return axios.get(endpoints[1]);
      })
      .then((resp) => {
        let arr = resp.data.sort((a, b) => (a.new_name.toUpperCase() > b.new_name.toUpperCase()) ? 1 : ((b.new_name.toUpperCase() > a.new_name.toUpperCase()) ? -1 : 0));
        setCategory2(arr.map((row) => {
          return { id: row.new_category2id, name: row.new_name, parent_category: row._new_parentcategory_value };
        }));
        
        return axios.get(endpoints[2]);
      })
      .then((resp) => {
        let arr = resp.data.sort((a, b) => (a.new_name.toUpperCase() > b.new_name.toUpperCase()) ? 1 : ((b.new_name.toUpperCase() > a.new_name.toUpperCase()) ? -1 : 0));
        setCategory3(arr.map((row) => {
          return { id: row.new_category3id, name: row.new_name, parent_category: row._new_parentcategory_value };
        }));
      })
      .catch(() => {
        LogOut()
      });
      
    axios.get('https://ticketapi.rowad-app.com/tickets/mvcases')
      .then((response) => {
        const data = response.data;
        const shells = data
          .filter(item => item.new_type === 'shell')
          .map(item => ({
            id: item.new_mvcaseid,
            name: item.new_name
          }));
        setShellOptions(shells);

        const businessProcesses = data
          .filter(item => item.new_type === 'business')
          .map(item => ({
            id: item.new_mvcaseid,
            name: item.new_name
          }));
        setBusinessProcessOptions(businessProcesses);

        const projects = data
          .filter(item => item.new_type === 'project')
          .map(item => ({
            id: item.new_mvcaseid,
            name: item.new_name
          }));
        setProjectOptions(projects);
      })
      .catch((error) => {
        console.error("Error fetching mvcases:", error);
      });
  }, []);

  return (
    <>
      <Header />
      <div className="container">
   
        <div className="signin-box">
        <h1 style={{"textAlign":'center'}}>Create Ticket</h1>
          <Formik
            initialValues={{
              location: "",
              ServiceCategory1: "",
              ServiceCategory2: "",
              ServiceCategory3: "",
              token:"",
              Issue: "",
              attachments:[],
              new_shell: "",
              new_businessprocess: "",
              new_project: "",
              new_recordno: ""
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
              setLoadingAPI(true)
              const { location, ...caseValues } = values; // Destructure to remove location
              const caseData = {
                "case": {
                  "new_Category1@odata.bind": `/new_category1s(${caseValues.ServiceCategory1})`, 
                  "new_Category2@odata.bind": `/new_category2s(${caseValues.ServiceCategory2})`,
                  "new_Category3@odata.bind": `/new_category3s(${caseValues.ServiceCategory3})`,
                  "new_Requester@odata.bind":`/new_userstses(${Cookies.get('token')})`,
                  "new_description": `${caseValues.Issue}`
                },
                "attachments": caseValues.attachments.length > 0 ? caseValues.attachments : null,
              };

              // Add Unifier fields if they exist
              if (caseValues.new_shell) {
                caseData.case.new_shell = caseValues.new_shell;
              }
              if (caseValues.new_businessprocess) {
                caseData.case.new_businessprocess = caseValues.new_businessprocess;
              }
              if (caseValues.new_project) {
                caseData.case.new_project = caseValues.new_project;
              }
              if (caseValues.new_recordno) {
                caseData.case.new_recordno = caseValues.new_recordno;
              }

              axios.post(`${process.env.REACT_APP_Back_URL}/tickets/cases`, caseData)
                .then((response) => {
                
                  MySwal.fire({
                    title: "Ticket Submitted",
                    html: "You will be redirected shortly",
                    timer: 10000,
                    timerProgressBar: true,
                    didOpen: () => {
                      MySwal.showLoading();
                      MySwal.getPopup().querySelector("b");  
                    },
          
                  }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                      console.log("I was closed by the timer");
                      navigate('/')
                    }
                  });
                  console.log("Form submitted successfully!", response.data);
                  resetForm();
                })
                .catch((error) => {
                  console.error("Error submitting form:", error);
                });
            }}
          >
            {({ values,touched, errors, setFieldValue, setSubmitting }) => (
              <Form>
                <div className="input-group">
                  <label htmlFor="location">Please select your current location الرجاء تحديد موقعك الحالي</label>
                  <Field
                    as="select"
                    name="location"
                    onChange={(e) => {
                      setFieldValue("location", e.target.value);
                      setFieldValue("ServiceCategory1", "");
                      setFieldValue("ServiceCategory2", "");
                      setFieldValue("ServiceCategory3", "");
                      setSelectedLocation(e.target.value);
                    }}
                  >
                    <option value="">Select Location اختر الموقع</option>
                    <option value="head_office">Head Office المكتب الرئيسي</option>
                    <option value="site">Site الموقع</option>
                  </Field>
                  {errors.location && touched.location ? (
                    <div className="error">{errors.location}</div>
                  ) : null}
                </div>

                <div className="input-group">
                  <label htmlFor="ServiceCategory1">Select Department to provide you service حدد القسم الذي سيتم تقديم الخدمة</label>
                  <Field
                    as="select"
                    name="ServiceCategory1"
                    disabled={!values.location}
                    onChange={(e) => {
                      setFieldValue("ServiceCategory1", e.target.value);
                      setFieldValue("ServiceCategory2", "");
                      setFieldValue("ServiceCategory3", "");
                      const selectedCategory = Category1.find(cat => cat.id === e.target.value);
                      setShowUnifierFields(selectedCategory?.name.toLowerCase().includes('unifier'));
                    }}
                  >
                    <option value="">Select a Department</option>
                    {Category1
                      .filter(category => {
                        if (values.location === 'head_office') {
                          return !category.name.toLowerCase().includes('site');
                        } else if (values.location === 'site') {
                          return !category.name.toLowerCase().includes('head office');
                        }
                        return true;
                      })
                      .map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                    ))}
                  </Field>
                  {errors.ServiceCategory1 && touched.ServiceCategory1 ? (
                    <div className="error">{errors.ServiceCategory1}</div>
                  ) : null}
                </div>

                <div className="input-group">
                  <label htmlFor="ServiceCategory2">Select the general issue حدد المشكله العامة</label>
                  <Field
                    as="select"
                    name="ServiceCategory2"
                    disabled={!values.ServiceCategory1}
                    onChange={(e) => {
                      setFieldValue("ServiceCategory2", e.target.value);
                      setFieldValue("ServiceCategory3", "");
                    }}
                  >
                    <option value="">Select a General Issue</option>
                    {Category2.filter((item) => item.parent_category === values.ServiceCategory1).map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </Field>
                  {errors.ServiceCategory2 && touched.ServiceCategory2 ? (
              <div className="error">{errors.ServiceCategory2}</div>
            ) : null}
                </div>
                

                <div className="input-group">
                  <label  htmlFor="ServiceCategory3">Select the specific issue حدد المشكلة المحددة</label>
                  <Field
                    as="select"
                    name="ServiceCategory3"
                    required
                    disabled={!values.ServiceCategory2}
                  >
                    <option value="">Select a Specific Issue</option>
                    {Category3.filter((item) => item.parent_category === values.ServiceCategory2).map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </Field>
                  {errors.ServiceCategory3 && touched.ServiceCategory3 ? (
              <div className="error">{errors.ServiceCategory3}</div>
            ) : null}
                </div>

                {showUnifierFields && (
                  <>
                    <div className="input-group">
                      <label htmlFor="new_shell">Shell</label>
                      <Field name="new_shell">
                        {({ field, form }) => (
                          <Autocomplete
                            multiple
                            options={shellOptions}
                            getOptionLabel={(option) => option.name}
                            onChange={(_, values) => {
                              const combinedValue = values.map(v => v.name).join(', ');
                              form.setFieldValue('new_shell', combinedValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                {...field}
                                placeholder="Select Shell(s)"
                                error={form.touched.new_shell && Boolean(form.errors.new_shell)}
                                helperText={form.touched.new_shell && form.errors.new_shell}
                              />
                            )}
                          />
                        )}
                      </Field>
                    </div>

                    <div className="input-group">
                      <label htmlFor="new_businessprocess">Business Process</label>
                      <Field name="new_businessprocess">
                        {({ field, form }) => (
                          <Autocomplete
                            multiple
                            options={businessProcessOptions}
                            getOptionLabel={(option) => option.name}
                            onChange={(_, values) => {
                              const combinedValue = values.map(v => v.name).join(', ');
                              form.setFieldValue('new_businessprocess', combinedValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                {...field}
                                placeholder="Select Business Process(es)"
                                error={form.touched.new_businessprocess && Boolean(form.errors.new_businessprocess)}
                                helperText={form.touched.new_businessprocess && form.errors.new_businessprocess}
                              />
                            )}
                          />
                        )}
                      </Field>
                    </div>

                    <div className="input-group">
                      <label htmlFor="new_project">Project</label>
                      <Field name="new_project">
                        {({ field, form }) => (
                          <Autocomplete
                            multiple
                            options={projectOptions}
                            getOptionLabel={(option) => option.name}
                            onChange={(_, values) => {
                              const combinedValue = values.map(v => v.name).join(', ');
                              form.setFieldValue('new_project', combinedValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                {...field}
                                placeholder="Select Project(s)"
                                error={form.touched.new_project && Boolean(form.errors.new_project)}
                                helperText={form.touched.new_project && form.errors.new_project}
                              />
                            )}
                          />
                        )}
                      </Field>
                    </div>

                    <div className="input-group">
                      <label htmlFor="new_recordno">Record Number</label>
                      <Field name="new_recordno">
                        {({ field, form }) => (
                          <TextField
                            {...field}
                            fullWidth
                            placeholder="Enter Record Number"
                            error={form.touched.new_recordno && Boolean(form.errors.new_recordno)}
                            helperText={form.touched.new_recordno && form.errors.new_recordno}
                          />
                        )}
                      </Field>
                    </div>
                  </>
                )}

                <div className="input-group">
                  <label htmlFor="Issue">Issue Description</label>
                  <Field as="textarea" id="Issue" name="Issue" placeholder="e.g. Please, I need Primeavera fresh Installation on my laptop" />
                  {errors.Issue && touched.Issue ? (
              <div className="error">{errors.Issue}</div>
            ) : null}
                </div>
 
                <div className="input-group">
                  <label htmlFor="Issue">Attachments (Optional - Max 5 files, 15MB each)</label>
                  <Field as="input"
                    id="file"
                    name="front_id_image"
                    type="file"
                    multiple
                    onChange={(e) => {
                      if(e.target.files.length > 0){
                        const files = Array.from(e.target.files);
                        const newAttachments = [];
                        let processedCount = 0;
                        
                        files.forEach((file, index) => {
                          const data = new FileReader();
                          data.addEventListener('load', () => {
                            newAttachments.push({
                              "filename": file.name,
                              "isdocument": true,
                              "mimetype": file.type,
                              "documentbody": data.result.split('base64,')[1],
                              "filesize": file.size
                            });
                            processedCount++;
                            
                            if (processedCount === files.length) {
                              setFieldValue('attachments', [...values.attachments, ...newAttachments]);
                            }
                          });
                          data.readAsDataURL(file);
                        });
                      }
                    }}
                  />
                  
                  {/* Display selected files */}
                  {values.attachments && values.attachments.length > 0 && (
                    <div style={{ marginTop: '10px' }}>
                      <strong>Selected Files:</strong>
                      <ul style={{ listStyle: 'none', padding: 0 }}>
                        {values.attachments.map((file, index) => (
                          <li key={index} style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            padding: '5px 0',
                            borderBottom: '1px solid #eee'
                          }}>
                            <span style={{ fontSize: '14px' }}>
                              📎 {file.filename} ({(file.filesize / 1024 / 1024).toFixed(2)} MB)
                            </span>
                            <button 
                              type="button"
                              onClick={() => {
                                const updatedAttachments = values.attachments.filter((_, i) => i !== index);
                                setFieldValue('attachments', updatedAttachments);
                              }}
                              style={{
                                background: '#ff4444',
                                color: 'white',
                                border: 'none',
                                borderRadius: '3px',
                                padding: '2px 8px',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              Remove
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  
                  {errors.attachments && touched.attachments ? (
                    <div className="error">{errors.attachments}</div>
                  ) : null}
                </div>

 <br/> 
                <Grid container spacing={2}  style={{       justifyContent:"center",
      alignItems:"center" }}>
      
                  <Field
                    as="HCaptcha"
                    name="hcaptcha"
                    render={({ field }) => (
                      <HCaptcha
                       
                        sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                        onVerify={(token) => {
                          setFieldValue("token", token);
                          setSubmitting(false);
                        }}
                        onExpire={() => {
                          setFieldValue("token", "");
                        }}
                      />
                    )}
 
                  />


                
                </Grid>
                {errors.token && touched.token ? (
              <div className="error" style={{textAlign:"left !important"}}>{errors.token}</div>
            ) : null}
               <LoadingButton variant="contained"
                    loading={LoadingAPI}
                    type="submit"
                    color="success"
                  >
                  Submit
                </LoadingButton>

                {/* <button >Submit</button> */}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

export default NewTicket;